import React from "react";
import {
  AccordionItem,
  AccordionPanel,
  Box,
  VStack,
} from "@chakra-ui/react";
import Topic from "./Topic";

interface TopicCollectionProps {
  tags: string[]; // may be replaced with ID in future
  //id: string;
  childContent: any[];
  // childIds: string[]
  toggleGameLiftStreamsInput: any;
}

const TopicCollection: React.FC<TopicCollectionProps> = ({ tags, childContent, toggleGameLiftStreamsInput }) => {
  return (
    <AccordionPanel>
      <AccordionItem border="none" isDisabled={false} isFocusable={false}>
        <VStack align="left">
          {childContent.map((subtopic) => (
            // in theory you could use a field in checkboxContent for a switch statement
            // here to be able to render multiple components in this container
            // This would allow you to define multiple assessment schemas in contentful
            <Box>
              <Topic
                title={subtopic.fields.subtopicName}
                childContent={subtopic.fields.allCriteria}
                tags={[...tags, subtopic.fields.tag]}
                toggleGameLiftStreamsInput={toggleGameLiftStreamsInput}
              />
            </Box>
          ))}
        </VStack>
      </AccordionItem>
    </AccordionPanel>
  )
}

export default TopicCollection;
